import { useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

import MDBox from "components/MDBox";
import { useMaterialUIController, setLayout } from "context";

function DashboardLayout({ children }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  return (
    <MDBox
      sx={({ functions: { pxToRem }, transitions }) => ({
        position: "relative",
        minHeight: "100vh",
        background: "#f5f5f5",
        padding: "24px",
        marginLeft: miniSidenav ? pxToRem(80) : pxToRem(274),
        //border: "5px solid red", // TEMP visuel
        transition: "margin-left 0.4s ease-in-out",
      })}
    >
      <div style={{ padding: "20px" }}>{children}</div>
    </MDBox>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
